import React from "react";
import AccountPage from "../account/AccountPage";
export default function SignUp() { return <AccountPage mode="register"/>; }
